import React, { ReactElement } from 'react';
import EditPripomienkaComponent from './component/EditPripomienkaComponent';
import PripomienkaDetail from '../../model/pripomienka/PripomienkaDetail';

interface Props {
  pripomienkaDetail: PripomienkaDetail;
}
const EditPripomienka = ({
  pripomienkaDetail,
}: Props): ReactElement => (
  <EditPripomienkaComponent
    pripomienkaDetail={pripomienkaDetail}
  />
);

export default EditPripomienka;
